import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=666fef99&scoped=true"
import script from "./ConfirmationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666fef99",
  null
  
)

export default component.exports